<template>
  <div>
    <div class="vx-col w-1/3 items-center sm:flex hidden">
      <!-- Add new event button -->
      <vs-button class="mb-6" icon-pack="feather" icon="icon-plus" @click="promptAddNew()"
        >Add New</vs-button
      >
    </div>
    <div id="data-list-thumb-view" class="data-list-container">
      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        search
        :data="users"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  users.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : users.length
                }}
                of {{ (queriedItems = users.length ? users.length : 20) }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 5">
                <span>5</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th>Name</vs-th>
          <vs-th sort-key="name">Email</vs-th>
          <vs-th sort-key="category">Course</vs-th>
          <vs-th sort-key="category">isEnabled</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td>
                <p class="product-category">{{ tr.email }}</p>
              </vs-td>
              <vs-td>
                <p class="product-price">{{ tr.courseTitle }}</p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <vs-switch v-model="tr.isEnabled" @click="toggleEnable(tr)" />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <AddUserCourse :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar(false)"/>
    <!-- <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="addNewDataSidebar"
    >

     <div class="mt-6 flex items-center justify-between px-6">
        <h4>ADD COURSE</h4>
        <feather-icon icon="XIcon" @click.stop="addNewDataSidebar = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mt-6"></vs-divider>
      <vs-select
        autocomplete
        @input-change="autoCompleteEmail"
        class="selectExample"
        label="Email"
        v-model="selectEmail"
      >
        <vs-select-item
          :key="index"
          :value="item.email"
          :text="item.email"
          v-for="(item, index) in allUsers"
        />
      </vs-select>
      <vs-select
        autocomplete
        multiple
        @input-change="autoCompleteCourses"
        class="selectExample"
        label="Course"
        v-model="selectCourses"
      >
        <vs-select-item
          :key="index"
          :value="item._id"
          :text="item.title"
          v-for="(item, index) in courses"
        />
      </vs-select>

      <div class="vx-col w-1/3 items-center sm:flex hidden mt-6">
        <vs-button @click="addUserCourse()">Save</vs-button>
      </div>
    </vs-sidebar> -->
  </div>
</template>

<script>
import moduleUserCourses from '@/store/userCourses/moduleUserCourses.js'
import AddUserCourse from '@/views/pages/add-userCourse.vue'

export default {
  components: {
    AddUserCourse
    // ManageCourse
  },
  data() {
    return {
      selected: [],
      // users: [],
      addNewDataSidebar: false,
      selectEmail: '',
      selectCourses: '',
      switch1: false,
      itemsPerPage: 4,
      currentPage: 1,
      isMounted: false,
      dialogAddData: false
    }
  },
  computed: {
    // currentPage () {
    //   if (this.isMounted) {
    //     return this.$refs.table.currentx
    //   }
    //   return 0
    // },
    users() {
      return this.$store.state.userCourses.userCourses
    },
    allUsers() {
      return this.$store.state.userCourses.allUsers
    },
    count() {
      return this.$store.state.userCourses.count
    },
    courses() {
      return this.$store.state.userCourses.courses
    }
    // queriedItems () {
    //   return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
    // }
  },
  methods: {
    toggleDataSidebar(val) {
      this.addNewDataSidebar = val
    },
    promptAddNew() {
      this.dialogAddData = true
      this.addNewDataSidebar = true
      // this.toggleDataSidebar(true)
      this.$store.dispatch('userCourses/fetchCourses')
      this.$store.dispatch('userCourses/fetchUsers')
    },
    toggleEnable(item) {
      let data = JSON.parse(JSON.stringify(item))
      data.isEnabled = !data.isEnabled
      console.log(data)
      this.$store.dispatch('userCourses/updateUserCourses', data)
    },
    autoCompleteCourses() {
      console.log(this.selectCourses)
    },
    autoCompleteEmail() {
      console.log(this.selectEmail)
    },
    addUserCourse() {
      if (this.selectEmail && this.selectCourses.length) {
        let payload = {
          courses: this.selectCourses,
          email: this.selectEmail
        }
        this.$store.dispatch('userCourses/addUserCourses', payload)
        this.addNewDataSidebar = false
        this.dialogAddData = false
        payload = {}
        this.selectCourses = []
        this.selectEmail = []
      }
    }
  },
  watch: {
    selectCourses(val) {
      this.autoCompleteCourses(val)
    },
    selectEmail(val) {
      this.autoCompleteEmail(val)
    }
  },
  created() {
    if (!moduleUserCourses.isRegistered) {
      this.$store.registerModule('userCourses', moduleUserCourses)
      moduleUserCourses.isRegistered = true
    }
    this.$store.dispatch('userCourses/fetchUserCourses')
  },
  mounted() {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
